import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import About from '@/views/About.vue';
import Article from '@/views/Article.vue';
import Login from '@/views/Login.vue';
import Admin from '@/views/Admin.vue';
import AdminHome from '@/views/Admin/AdminHome.vue';
import Add from '@/views/Admin/Add.vue';
import NotFound from '@/views/NotFound.vue';
import { auth } from '@/store/firebase.js';
import store from '@/store/index.js';


Vue.use(VueRouter)

// A list of route records
const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/article/:id',
    name: 'Article',
    component: Article
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/admin',
    component: Admin,
    children: [{
        path: '', // 默认加载的嵌套组件
        name: 'AdminHome',
        component: AdminHome,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'add',
        name: 'AdminAdd',
        component: Add,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'edit/:id',
        name: 'AdminEdit',
        component: Add,
        meta: {
          requiresAuth: true
        }
      },
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  },
]

const router = new VueRouter({
  routes
})

// Nav Guard
router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    await auth.onAuthStateChanged(user => {
      if (user) {
        store.commit("LOGIN");
        next();
      } else {
        next({path: '/login'})
      }
    })
  } else {
    next();
  }
});

export default router